

import {
  Component,
  OnInit,
} from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { NGXLogger } from "ngx-logger";
import { ConfirmationService, MenuItem, MessageService } from "primeng/api";

import {
  DialogService,
  DynamicDialogConfig,
  DynamicDialogRef,
} from "primeng/dynamicdialog";
import { Subject } from "rxjs";
import { Impresa } from "src/app/models/impresa.model";
import { Listino } from "src/app/models/listino.model";
import { ImpreseService } from "src/app/services/imprese.service";
import { ListiniService } from "src/app/services/listini.service";


@Component({
  templateUrl: "./dialog-modifica-regione.component.html",
  styleUrls: ["../listino.component.css"],
})
export class ModificaRegioneComponent implements OnInit {
  protected _onDestroy              = new Subject<void>();
  public modificaListinoForm: FormGroup;
  protected listinoDaModificare:Listino; 
  protected isUpdatingListino:Boolean = false;
  protected regione:string;

  constructor(
    private logger: NGXLogger,
    public dialogRef: DynamicDialogRef,
    public config: DynamicDialogConfig,
    private impreseService: ImpreseService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private _formBuilder: FormBuilder,
    private listiniService:ListiniService,
  ) {
    this.listinoDaModificare = this.config.data.listino;
    this.regione = this.config.data.regione;
    this.modificaListinoForm = this._formBuilder.group({
      regione:                    [null],
      scl1:                       [this.regione === 'LIGURIA'?this.listinoDaModificare.liguria1: this.regione === 'PIEMONTE'?this.listinoDaModificare.piemonte1:this.listinoDaModificare.sardegna1, [Validators.required]],
      scl2:                       [this.regione === 'LIGURIA'?this.listinoDaModificare.liguria2: this.regione === 'PIEMONTE'?this.listinoDaModificare.piemonte2:this.listinoDaModificare.sardegna2, [Validators.required]],
      scl3:                       [this.regione === 'LIGURIA'?this.listinoDaModificare.liguria3: this.regione === 'PIEMONTE'?this.listinoDaModificare.piemonte3:this.listinoDaModificare.sardegna3, [Validators.required]],
      scl4:                       [this.regione === 'LIGURIA'?this.listinoDaModificare.liguria4: this.regione === 'PIEMONTE'?this.listinoDaModificare.piemonte4:this.listinoDaModificare.sardegna4, [Validators.required]],
      scl5:                       [this.regione === 'LIGURIA'?this.listinoDaModificare.liguria5: this.regione === 'PIEMONTE'?this.listinoDaModificare.piemonte5:this.listinoDaModificare.sardegna5, [Validators.required]],
      preventivoBase:             [this.regione === 'LIGURIA'?this.listinoDaModificare.preventivoBaseLiguria: this.regione === 'PIEMONTE'?this.listinoDaModificare.preventivoBasePiemonte:this.listinoDaModificare.preventivoBaseSardegna, [Validators.required]]
    });
  }

  ngOnInit(): void {
    
    this.modificaListinoForm.get('scl2')?.valueChanges.subscribe(() => this.updatePreventivoBase());
    this.modificaListinoForm.get('scl3')?.valueChanges.subscribe(() => this.updatePreventivoBase());
    this.modificaListinoForm.get('scl5')?.valueChanges.subscribe(() => this.updatePreventivoBase());

  }

  updatePreventivoBase() {
    const scl2 = this.modificaListinoForm.get('scl2')?.value || 0;
    const scl3 = this.modificaListinoForm.get('scl3')?.value || 0;
    const scl5 = this.modificaListinoForm.get('scl5')?.value || 0;
    this.modificaListinoForm.get('preventivoBase')?.setValue(scl2 + scl3 + scl5, { emitEvent: false });
  }
  

  conferma(conferma: boolean) {
    if (!conferma) {
      this.dialogRef.close({ success: false });
    } else {
      this.isUpdatingListino = true;
      if(this.regione === 'LIGURIA'){
        this.listinoDaModificare.liguria1               = this.modificaListinoForm.value.scl1;
        this.listinoDaModificare.liguria2               = this.modificaListinoForm.value.scl2;
        this.listinoDaModificare.liguria3               = this.modificaListinoForm.value.scl3;
        this.listinoDaModificare.liguria4               = this.modificaListinoForm.value.scl4;
        this.listinoDaModificare.liguria5               = this.modificaListinoForm.value.scl5;
        this.listinoDaModificare.preventivoBaseLiguria  = this.modificaListinoForm.value.preventivoBase;
        this.listinoDaModificare.piemonte1 = null;
        this.listinoDaModificare.piemonte2 = null;
        this.listinoDaModificare.piemonte3 = null;
        this.listinoDaModificare.piemonte4 = null;
        this.listinoDaModificare.piemonte5 = null;
        this.listinoDaModificare.preventivoBasePiemonte = null;
        this.listinoDaModificare.sardegna1 = null;
        this.listinoDaModificare.sardegna2 = null;
        this.listinoDaModificare.sardegna3 = null;
        this.listinoDaModificare.sardegna4 = null;
        this.listinoDaModificare.sardegna5 = null;
        this.listinoDaModificare.preventivoBaseSardegna = null;

      }else if(this.regione === 'PIEMONTE'){
        this.listinoDaModificare.piemonte1               = this.modificaListinoForm.value.scl1;
        this.listinoDaModificare.piemonte2               = this.modificaListinoForm.value.scl2;
        this.listinoDaModificare.piemonte3               = this.modificaListinoForm.value.scl3;
        this.listinoDaModificare.piemonte4               = this.modificaListinoForm.value.scl4;
        this.listinoDaModificare.piemonte5               = this.modificaListinoForm.value.scl5;
        this.listinoDaModificare.preventivoBasePiemonte  = this.modificaListinoForm.value.preventivoBase;
       
        this.listinoDaModificare.liguria1               = null;
        this.listinoDaModificare.liguria2               = null;
        this.listinoDaModificare.liguria3               = null;
        this.listinoDaModificare.liguria4               = null;
        this.listinoDaModificare.liguria5               = null;
        this.listinoDaModificare.preventivoBaseLiguria  = null;
        
        this.listinoDaModificare.sardegna1 = null;
        this.listinoDaModificare.sardegna2 = null;
        this.listinoDaModificare.sardegna3 = null;
        this.listinoDaModificare.sardegna4 = null;
        this.listinoDaModificare.sardegna5 = null;
        this.listinoDaModificare.preventivoBaseSardegna = null;
      }else if(this.regione === 'SARDEGNA'){
        this.listinoDaModificare.sardegna1               = this.modificaListinoForm.value.scl1;
        this.listinoDaModificare.sardegna2               = this.modificaListinoForm.value.scl2;
        this.listinoDaModificare.sardegna3               = this.modificaListinoForm.value.scl3;
        this.listinoDaModificare.sardegna4               = this.modificaListinoForm.value.scl4;
        this.listinoDaModificare.sardegna5               = this.modificaListinoForm.value.scl5;
        this.listinoDaModificare.preventivoBaseSardegna  = this.modificaListinoForm.value.preventivoBase;

        this.listinoDaModificare.liguria1               = null;
        this.listinoDaModificare.liguria2               = null;
        this.listinoDaModificare.liguria3               = null;
        this.listinoDaModificare.liguria4               = null;
        this.listinoDaModificare.liguria5               = null;
        this.listinoDaModificare.preventivoBaseLiguria  = null;

        this.listinoDaModificare.piemonte1 = null;
        this.listinoDaModificare.piemonte2 = null;
        this.listinoDaModificare.piemonte3 = null;
        this.listinoDaModificare.piemonte4 = null;
        this.listinoDaModificare.piemonte5 = null;
        this.listinoDaModificare.preventivoBasePiemonte = null;
       
      } 
     

       this.listiniService.modifica(this.listinoDaModificare).subscribe( {
            next: (resCreaProgetto) => {
              this.isUpdatingListino = false;
              this.dialogRef.close({ success: true });
            },
            error: (e) => {
                this.isUpdatingListino = false;
                this.logger.error(e);
                this.dialogRef.close({ success: false });
                this.messageService.add({
                  severity: "error",
                  summary: "ATTENZIONE",
                  detail: "Errore in fase di modifica del listino!", life:10000
                });
          },
            complete: () => {

              //this.isLoadingResults = false;
            }
        }); 
    }
  }
}
